import { BaseMixedFilters } from "@components/modules/documents/listing/MixedFilters";
import {
  ContractsWhereColumn,
  OrdersWhereColumn,
  OtherDocumentsWhereColumn,
} from "@src/__generated__/urql-graphql";

export class MixedFilters extends BaseMixedFilters {
  constructor(contractorId?: string) {
    super();

    this.where.contracts.hide([
      ContractsWhereColumn.BrandId,
      ContractsWhereColumn.ClientId,
      ContractsWhereColumn.ProjectId,
      ContractsWhereColumn.ContractorId,
    ]);
    this.where.orders.hide([
      OrdersWhereColumn.BrandId,
      OrdersWhereColumn.ProjectId,
    ]);
    this.where.otherDocuments.hide([]);

    if (contractorId) {
      this.where.contracts.addImplicitFilter(
        ContractsWhereColumn.ContractorId,
        contractorId,
      );
      this.where.otherDocuments.addImplicitFilter(
        OtherDocumentsWhereColumn.ContractorId,
        contractorId,
      );
    }
  }
}
